import type { CustomFlowbiteTheme } from 'flowbite-react';

export const darkThemeToggleTheme: CustomFlowbiteTheme['darkThemeToggle'] = {
  root: {
    base: 'rounded-lg p-2.5 text-sm text-titan-night-500 hover:bg-titan-night-100 focus:outline-none focus:ring-4 focus:ring-titan-night-200',
  },
};
